import ErrorBoundary from '@components/ErrorBoundary/ErrorBoundary';
import ErrorMessage from '@components/ErrorBoundary/ErrorMessage';
import ImageVerificator from '@components/sentinel/ImageVerificator/ImageVerificator';
import ImageVerificatorSkeleton from '@components/sentinel/skeleton/ImageVerificatorSkeleton/ImageVerificatorSkeleton';
import { Suspense } from 'react';

export default function VerificationAIImage() {
	return (
		<div id="verification-ai-image" className="sentinel-note">
			<ErrorBoundary errorComponent={ErrorMessage}>
				<Suspense fallback={<ImageVerificatorSkeleton />}>
					<ImageVerificator />
				</Suspense>
			</ErrorBoundary>
		</div>
	);
}
